import React, { useState } from "react";
import styled from "styled-components";
// Components
import PricingTable from "../Elements/PricingTable";
import { useNavigate } from "react-router-dom";

// Course Combination Popup Component
const CourseCombinationPopup = ({
  isOpen,
  onClose,
  courses,
  onGetMoreInfo,
}) => {
  if (!isOpen) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const parts = dateStr.split("-");
    if (parts.length === 3) {
      const [year, month, day] = parts;
      return `${day}-${month}-${year}`;
    }
    return dateStr;
  };

  const basicsCourse = courses.find((c) => c.title === "Stock Market Basics");
  const fundamentalCourse = courses.find(
    (c) => c.title === "Fundamental Analysis"
  );
  const technicalCourse = courses.find((c) => c.title === "Technical Analysis");
  const comboCourse = courses.find(
    (c) => c.title === "Basics + Fundamental + Technical"
  );

  return (
    <PopupOverlay onClick={onClose}>
      <PopupContent onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>&times;</CloseButton>

        <PopupHeader>
          <h2
            style={{ fontFamily: "Josefin Sans, sans-serif" }}
            className="text-2xl font-bold text-center mb-2"
          >
            Complete Stock Market Package
          </h2>
          <p className="text-gray-600 text-center mb-6">
            Get all three courses at a special discounted price
          </p>
        </PopupHeader>

        <CourseGrid>
          {basicsCourse && (
            <CourseCard>
              <div className="image-container mb-3">
                <img
                  src={basicsCourse.image}
                  alt={basicsCourse.title}
                  className="w-full rounded-lg"
                  style={{
                    height: "160px",
                    objectFit: "contain",
                    backgroundColor: "#f3f4f6",
                  }}
                />
              </div>
              <h3 className="font-semibold text-sm mb-1">
                {basicsCourse.title}
              </h3>
              <p className="text-xs text-gray-600">₹{basicsCourse.price}</p>
            </CourseCard>
          )}

          {fundamentalCourse && (
            <CourseCard>
              <div className="image-container mb-3">
                <img
                  src={fundamentalCourse.image}
                  alt={fundamentalCourse.title}
                  className="w-full rounded-lg"
                  style={{
                    height: "160px",
                    objectFit: "contain",
                    backgroundColor: "#f3f4f6",
                  }}
                />
              </div>
              <h3 className="font-semibold text-sm mb-1">
                {fundamentalCourse.title}
              </h3>
              <p className="text-xs text-gray-600">
                ₹{fundamentalCourse.price}
              </p>
            </CourseCard>
          )}

          {technicalCourse && (
            <CourseCard>
              <div className="image-container mb-3">
                <img
                  src={technicalCourse.image}
                  alt={technicalCourse.title}
                  className="w-full rounded-lg"
                  style={{
                    height: "160px",
                    objectFit: "contain",
                    backgroundColor: "#f3f4f6",
                  }}
                />
              </div>
              <h3 className="font-semibold text-sm mb-1">
                {technicalCourse.title}
              </h3>
              <p className="text-xs text-gray-600">₹{technicalCourse.price}</p>
            </CourseCard>
          )}
        </CourseGrid>

        <PricingSection>
          <div className="text-center ">
            <div className="mb-4">
              <span className="font-semibold">📆 Date: </span>
              <span className="inline-block bg-yellow-100 px-3 py-1  border border-yellow-400 text-yellow-800 font-semibold  rounded-md  shadow-sm text-bas">
                {formatDate(comboCourse?.date)}
              </span>
            </div>
            <div className="mb-4">
              <span className="text-gray-500 line-through">
                ₹
                {(basicsCourse?.price || 0) +
                  (fundamentalCourse?.price || 0) +
                  (technicalCourse?.price || 0)}
              </span>
              <span className="text-2xl font-bold text-green-600 ml-2">
                ₹{comboCourse?.price}
              </span>
              <span className="text-green-600 font-semibold ml-2">
                (Save ₹
                {(basicsCourse?.price || 0) +
                  (fundamentalCourse?.price || 0) +
                  (technicalCourse?.price || 0) -
                  comboCourse?.price}
                )
              </span>
            </div>
            <button
              onClick={onGetMoreInfo}
              className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors "
            >
              Get More Info & Book Now
            </button>
          </div>
        </PricingSection>
      </PopupContent>
    </PopupOverlay>
  );
};

export default function CourseTypes({ courses = [], loading }) {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  if (loading) {
    return <div className="mt-28 text-center">Loading...</div>;
  }

  // Static offers
  const staticOffers = [
    { name: "Live Interactive Session", cheked: true },
    { name: "Enrolled Learners : 500+", cheked: true },
    { name: "Access to tools and materials", cheked: true },
    { name: "& more...", cheked: false },
  ];

  const handleCourseClick = (course) => {
    if (course.title === "Basics + Fundamental + Technical") {
      setShowPopup(true);
    } else {
      navigate(`/course/${course.id}`);
    }
  };

  const handleGetMoreInfo = () => {
    const comboCourse = courses.find(
      (c) => c.title === "Basics + Fundamental + Technical"
    );
    setShowPopup(false);
    navigate("/payment-info", { state: { course: comboCourse } });
  };

  return (
    <Wrapper id="pricing">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1
              style={{ fontFamily: "Josefin Sans, sans-serif" }}
              className="font40 mt-12 extraBold text-center"
            >
              Courses we offer{" "}
            </h1>
          </HeaderInfo>
          <TablesWrapper className="flexSpaceNull">
            {courses.map((course) => (
              <TableBox key={course.id}>
                <PricingTable
                  icon="roller"
                  img={course.image}
                  price={`₹${course.price}`}
                  rating={
                    Number(course.rating) >= 1 && Number(course.rating) <= 5
                      ? Array(Number(course.rating)).fill("★").join(" ")
                      : "★ ★ ★ ★ ★"
                  }
                  title={course.title}
                  text={`🔔 in ${course.language}`}
                  offers={staticOffers}
                  action={() => handleCourseClick(course)}
                />
              </TableBox>
            ))}
          </TablesWrapper>
        </div>
      </div>

      <CourseCombinationPopup
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        courses={courses}
        onGetMoreInfo={handleGetMoreInfo}
      />
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 50px 0;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const TablesWrapper = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const TableBox = styled.div`
  width: 31%;
  @media (max-width: 860px) {
    width: 100%;
    max-width: 370px;
    margin: 0 auto;
  }
`;

// Popup styled components
const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const PopupContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2.5rem 2.5rem 0 2.5rem;
  max-width: 800px;
  width: 95%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    padding: 1.5rem 1.5rem 0 1.5rem;
    width: 90%;
    max-height: 85vh;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #6b7280;
  &:hover {
    color: #374151;
  }
`;

const PopupHeader = styled.div`
  margin-bottom: 1.5rem;
`;

const CourseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

const CourseCard = styled.div`
  text-align: center;
  padding: 1rem;
  border-radius: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 160px;
    border-radius: 8px;
    background: #f3f4f6;
    overflow: hidden;
  }

  img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }
`;

const PricingSection = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #f9fafb;
  padding: 1.5rem 0;
  box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.05);
  z-index: 10;

  @media (max-width: 768px) {
    position: static;
    padding: 1rem 0;
    box-shadow: none;
  }
`;
